const KEY = "menupro_business";

export const setBusiness = (biz) => {
  localStorage.setItem(KEY, JSON.stringify(biz));
};

export const getBusiness = () => {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const b = JSON.parse(raw);
    return b?.id ? b : null; // id yoxdursa null qaytar (qoruyucu)
  } catch {
    return null;
  }
};

export const logout = () => localStorage.removeItem(KEY);
